export default "__VITE_ASSET__rOwn5RlD__"